import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';
import { IPayoffRequestData } from '../../../types/order/title/IPayoffRequest';

export interface IPayoffRequestsState {
  payoffRequest: { [orderId: string]: IPayoffRequestData[] };
  payoffRequestFetchStatus: IFetchStatus;
  payoffRequestError: string | null;
  createPayoffRequestFetchStatus: IFetchStatus;
  createPayoffRequestError: string | null;
  cancelPayoffRequestFetchStatus: IFetchStatus;
  cancelPayoffRequestError: string | null;
}

export const payoffRequestsInitialState: IPayoffRequestsState = {
  payoffRequest: {},
  payoffRequestFetchStatus: createDefaultFetch(),
  payoffRequestError: null,
  createPayoffRequestFetchStatus: createDefaultFetch(),
  createPayoffRequestError: null,
  cancelPayoffRequestFetchStatus: createDefaultFetch(),
  cancelPayoffRequestError: null,
};
